import type { PropsWithChildren } from "react";

import AccountLayout from "@loyalty/layouts/AccountLayout/AccountLayout";
import GeneralLayout from "@loyalty/layouts/GeneralLayout/GeneralLayout";

import { useSelector } from "@jti/store/reduxHooks";
import { type RootStoreState } from "@jti/store/types";

import ScrollToElement from "../ScrollToElement/ScrollToElement";

type LayoutType = {
  name: "account" | (string & NonNullable<unknown>);
  isInEditor?: boolean;
  hideMyAddress?: boolean;
};

const LayoutWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const isLoaded = useSelector((state: RootStoreState) => state.loyaltyCore.isLoaded);
  return (
    <>
      {isLoaded && <ScrollToElement />}
      {children}
    </>
  );
};

export const Layout: React.FC<PropsWithChildren<LayoutType>> = ({
  children,
  name,
  isInEditor,
  hideMyAddress = false,
}) => {
  if (name === "account") {
    return (
      <LayoutWrapper>
        <AccountLayout isInEditor={isInEditor} hideMyAddress={hideMyAddress}>
          {children}
        </AccountLayout>
      </LayoutWrapper>
    );
  }

  return (
    <LayoutWrapper>
      <GeneralLayout isInEditor={isInEditor}>{children}</GeneralLayout>
    </LayoutWrapper>
  );
};
